import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STLYES
import * as MainMenuStyles from "../styles/mainMenu";

function MainMenu() {
    const navigate = useNavigate();

    const [items, setItems] = useState([
        {
            name: "Sections' Backgrounds",
            nav: "secBackgrounds"
        }
    ]);

    function handleCardClicked(id) {
        navigate(`./${items[id].nav}`);
    }

    return (
        <div style={MainMenuStyles.body}>
            {items.map((item, index) => {
                return (
                    <div key={index}>
                        <Card style={MainMenuStyles.card} onClick={handleCardClicked.bind(this, index)}>
                            <Card.Body>
                                <Row>
                                    <Col>{item.name}</Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </div>
                );
            })}
        </div>
    );
}

export default MainMenu;
